import React from 'react'
import {
  Button,
  Container,
  Popup,
  Bubble,
  HtmlContent
} from '@pdrj/pmi-iqos-ds-react'

const PointsRewardPopup = ({
  isOpen,
  onClose,
  pointsAwarded,
  htmlContent,
  translations
}) => {
  return (
    <Popup
      isOpen={isOpen}
      onCloseHandler={onClose}
      rounded
      fullScreenMobile={false}>
      <Container
        display={Container.displays.flex}
        flexDirection={Container.flexDirections.column}
        justifyContent={Container.justifyContentValues.center}
        alignItems={Container.alignItemsValues.center}>
        <Bubble
          content={pointsAwarded}
          variant={Bubble.variants.points}
          size={Bubble.sizes.l}
          header={translations.tk_pointsHeader}
          footer={translations.tk_pointsFooter}
        />
        <Container pt="10">
          <HtmlContent content={htmlContent} />
        </Container>
        <Container width="40" py="10">
          <Button
            onClickHandler={onClose}
            text={translations.tk_popupButtonClose}
            fullWidth
          />
        </Container>
      </Container>
    </Popup>
  )
}

export default PointsRewardPopup
